import { callOneApi } from '../common';
export var showShareMenu = function showShareMenu(params) {
  return callOneApi('showShareMenu', params);
};